<template>
    <div>
        <form v-if="!calculated" @submit.prevent="submit">
            <div class="form-group">
                <label>Loan Amount (USD):</label>
                <input
                    type="text"
                    v-model="form.loanAmount"
                    :class="['form-control', errors.loanAmount ? 'is-invalid' : '']"
                    placeholder="Enter loan amount"
                />
                <div v-if="errors.loanAmount" class="invalid-feedback">
                    {{ errors.loanAmount }}
                </div>
            </div>

            <div class="form-group">
                <label>Annual Interest Rate (%):</label>
                <input
                    type="text"
                    v-model="form.interestRate"
                    :class="['form-control', errors.interestRate ? 'is-invalid' : '']"
                    placeholder="Enter interest rate"
                />
                <div v-if="errors.interestRate" class="invalid-feedback">
                    {{ errors.interestRate }}
                </div>
            </div>

            <div class="form-group">
                <label>Repayment Period (Months):</label>
                <input
                    type="text"
                    v-model="form.repaymentPeriod"
                    :class="['form-control', errors.repaymentPeriod ? 'is-invalid' : '']"
                    placeholder="Enter repayment period in months"
                />
                <div v-if="errors.repaymentPeriod" class="invalid-feedback">
                    {{ errors.repaymentPeriod }}
                </div>
            </div>

            <div class="form-group">
                <button
                    :class="['btn btn-primary btn-block', form.loading ? 'btn-loading' : '']"
                    :disabled="form.loading"
                >
                    Calculate
                </button>
            </div>
        </form>

        <div v-if="calculated" class="result-container slide-in-left mt-4">
            <div class="alert alert-info text-center">
                <div class="py-3">
                    <h6 class="font-weight-400">
                        Your estimated monthly repayment is <b>{{ result.monthlyPayment }} USD</b>
                        for a total repayment of <b>{{ result.totalRepayment }} USD</b> over
                        <b>{{ form.repaymentPeriod }}</b> months.
                    </h6>
                </div>
            </div>
            <button @click="reset" class="btn btn-secondary btn-block">
                Perform Another Calculation
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                loanAmount: '',
                interestRate: '',
                repaymentPeriod: '',
                loading: false,
            },
            errors: {
                loanAmount: '',
                interestRate: '',
                repaymentPeriod: '',
            },
            calculated: false,
            result: {
                monthlyPayment: 0,
                totalRepayment: 0,
            },
        };
    },
    methods: {
        reset() {
            this.form.loanAmount = '';
            this.form.interestRate = '';
            this.form.repaymentPeriod = '';
            this.errors.loanAmount = '';
            this.errors.interestRate = '';
            this.errors.repaymentPeriod = '';
            this.calculated = false;
        },
        validateForm() {
            let isValid = true;

            // Validate Loan Amount
            if (!this.form.loanAmount || isNaN(this.form.loanAmount) || parseFloat(this.form.loanAmount) <= 0) {
                this.errors.loanAmount = 'Please enter a valid loan amount (must be a positive number).';
                isValid = false;
            } else {
                this.errors.loanAmount = '';
            }

            // Validate Interest Rate
            if (!this.form.interestRate || isNaN(this.form.interestRate) || parseFloat(this.form.interestRate) <= 0) {
                this.errors.interestRate = 'Please enter a valid annual interest rate (must be a positive number).';
                isValid = false;
            } else {
                this.errors.interestRate = '';
            }

            // Validate Repayment Period
            if (!this.form.repaymentPeriod || isNaN(this.form.repaymentPeriod) || parseInt(this.form.repaymentPeriod) <= 0) {
                this.errors.repaymentPeriod = 'Please enter a valid repayment period in months (must be a positive number).';
                isValid = false;
            } else {
                this.errors.repaymentPeriod = '';
            }

            return isValid;
        },
        submit() {
            if (!this.validateForm()) {
                return;
            }

            this.form.loading = true;

            // Calculate monthly repayment and total repayment
            const principal = parseFloat(this.form.loanAmount);
            const monthlyRate = parseFloat(this.form.interestRate) / 100 / 12;
            const months = parseInt(this.form.repaymentPeriod);

            const numerator = monthlyRate * Math.pow(1 + monthlyRate, months);
            const denominator = Math.pow(1 + monthlyRate, months) - 1;

            const monthlyPayment = principal * (numerator / denominator);
            this.result.monthlyPayment = monthlyPayment.toFixed(2);
            this.result.totalRepayment = (monthlyPayment * months).toFixed(2);

            this.calculated = true;
            this.form.loading = false;
        },
    },
};
</script>

<style scoped>
@keyframes slideInLeft {
    from {
        transform: translateX(-100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.slide-in-left {
    animation: slideInLeft 0.5s ease-in-out;
}
</style>
